// Generated by project/scripts/export-admin-feature-permissions.php. Do not edit.
export const currentPermissionCodes = [
  'meetingSales',
  'meetingSalesActivity',
  'meetingSalesActivityList',
  'meetingSalesActivityEdit',
  'meetingSalesActivityReview',
  'meetingSalesActivityDelete',
  'meetingSalesActivityShare',
  'meetingSalesActivityCheckinCode',
  'meetingSalesActivityStopRegistration',
  'meetingSalesActivityResumeRegistration',
  'meetingSalesActivityDetail',
  'meetingSalesRegistration',
  'meetingSalesRegistrationList',
  'meetingSalesRegistrationEdit',
  'meetingSalesRegistrationReview',
  'meetingSalesRegistrationImport',
  'meetingSalesRegistrationExport',
  'meetingSalesGroup',
  'meetingSalesGroupList',
  'meetingSalesGroupEdit',
  'meetingSalesGroupDelete',
  'meetingSalesGroupAuto',
  'meetingSalesGroupImport',
  'meetingSalesGroupLeaders',
  'meetingSalesGroupExport',
  'meetingSalesMembers',
  'meetingSalesMembersList',
  'meetingSalesMembersEdit',
  'meetingSalesMembersExport',
  'meetingSalesHotel',
  'meetingSalesHotelList',
  'meetingSalesHotelEdit',
  'meetingSalesHotelDelete',
  'meetingSalesHotelShare',
  'meetingSalesHotelDetail',
  'meetingSalesRoom',
  'meetingSalesRoomList',
  'meetingSalesRoomEdit',
  'meetingSalesRoomDelete',
  'meetingSalesRooming',
  'meetingSalesRoomingList',
  'meetingSalesRoomingEdit',
  'meetingSalesRoomingAuto',
  'meetingSalesRoomingImport',
  'meetingSalesRoomingExport',
  'meetingSalesBooking',
  'meetingSalesBookingList',
  'meetingSalesBookingEdit',
  'meetingSalesBookingReview',
  'meetingSalesBookingImport',
  'meetingSalesBookingExport',
  'frontend',
  'frontendExperienceCamp',
  'frontendExperienceCampList',
  'frontendExperienceCampRepairBindings',
  'frontendAutoOps',
  'frontendHostedWx',
  'frontendHostedWxList',
  'frontendHostedWxLogin',
  'frontendHostedWxEdit',
  'frontendHostedWxToggle',
  'frontendHostedWxDelete',
  'frontendHostedWxRefresh',
  'frontendHostedWxLogs',
  'frontendJuziAccount',
  'frontendJuziAccountList',
  'frontendJuziAccountSync',
  'frontendSopTemplate',
  'frontendSopTemplateList',
  'frontendSopTemplateCreate',
  'frontendSopTemplateEdit',
  'frontendSopTemplateEnable',
  'frontendSopTemplateDisable',
  'frontendSopTemplateCopy',
  'frontendSopTemplateDelete',
  'frontendSopTemplateImport',
  'frontendTask',
  'frontendTaskList',
  'frontendTaskCreate',
  'frontendTaskDelete',
  'frontendTaskPause',
  'frontendTaskResume',
  'frontendTaskTerminate',
  'frontendTaskRetryNow',
  'frontendTaskConfirm',
  'frontendTaskResend',
  'frontendTaskTrace',
  'content',
  'customPage',
  'customPageList',
  'page:list',
  'page:create',
  'page:edit',
  'page:delete',
  'page:publish',
  'page:copy',
  'page:category-manage',
  'page:configure',
  'page:analytics',
  'customForm',
  'customFormList',
  'form:list',
  'form:create',
  'form:edit',
  'form:publish',
  'form:copy',
  'form:delete',
  'form:add-data',
  'form:preview',
  'form:submissions',
  'form:export',
  'form:submitters',
  'form:report',
  'materialLibrary',
  'material:list',
  'material:create',
  'material:edit',
  'material:delete',
  'material:publish',
  'material:configure',
  'material:analytics',
  'shortLink',
  'short-link:list',
  'short-link:create',
  'short-link:edit',
  'workWxNativePayment',
  'workWxNativePaymentCreate',
  'systemApplicationCenter',
  'systemWechatPublicAccounts',
  'systemWechatPublicAccountsCreate',
  'systemWechatPublicAccountsEdit',
  'systemWechatPublicAccountsDelete',
  'systemWechatPublicAccountsToggle',
  'systemWechatApps',
  'systemWechatAppsCreate',
  'systemWechatAppsEdit',
  'systemWechatAppsDelete',
  'systemWechatAppsToggle',
  'systemWorkWxApps',
  'systemWorkWxAppsSyncMembers',
  'systemWorkWxAppsSyncContacts',
  'systemWorkWxAppsSyncTags',
  'systemWorkWxAppsSyncGroupChats',
  'systemFeiShuApps',
  'systemFeiShuAppsCreate',
  'systemFeiShuAppsEdit',
  'systemFeiShuAppsSyncDepartments',
  'systemFeiShuAppsSyncMembers',
  'dataCustomerTag',
  'dataCustomerTagCreate',
  'dataCustomerTagCreateWorkWx',
  'dataCustomerTagEdit',
  'dataCustomerTagAssign',
  'dataCustomerTagSyncWorkWx',
  'systemRole',
  'systemRoleCreate',
  'systemRoleEdit',
  'systemRoleMembers',
  'dataCustomerBehavior',
  'dataCustomerBehaviorUser',
  'dataCustomerBehaviorRecord',
  'dataCustomerBehaviorDefinition',
  'dataCustomerList',
  'dataCustomerListCreate',
  'dataCustomerListEdit',
  'dataCustomerField',
  'dataCustomerFieldCreate',
  'dataCustomerFieldEdit',
  'dataCustomerFieldReorder',
  'dataCustomerStage',
  'dataCustomerStageCreate',
  'dataCustomerStageEdit',
  'dataCustomerStageDelete',
  'dataCustomerStageToggle',
  'dataCustomerStageReorder',
  'dataCustomerSource',
  'dataCustomerSourceCreate',
  'dataCustomerSourceEdit',
  'dataCustomerSourceDelete',
  'dataCustomerSourceToggle',
  'dataCustomerSourceReorder',
  'dataCustomerChannel',
  'dataCustomerChannelCreate',
  'dataCustomerChannelEdit',
  'dataCustomerChannelDelete',
  'dataCustomerChannelToggle',
  'dataCustomerChannelReorder',
  'dataWorkflow',
  'dataWorkflowCreate',
  'dataWorkflowEdit',
  'dataWorkflowCopy',
  'dataWorkflowDelete',
  'dataWorkflowPublish',
  'dataWorkflowExecute',
  'dataWorkflowToggle',
  'dataWorkflowLogs',
  'projectList',
  'projectListCreate',
  'projectListEdit',
  'projectListDelete',
  'systemCourse',
  'systemCourseCreate',
  'systemCourseEdit',
  'systemCourseDelete',
  'systemCoursePeriod',
  'systemCoursePeriodCreate',
  'systemCoursePeriodEdit',
  'systemCoursePeriodLessonEdit',
  'systemCoursePeriodLessonDelete',
  'systemCoursePeriodSyncLessons',
  'systemCoursePeriodSyncStudents',
  'systemProduct',
  'systemProductCreate',
  'systemProductEdit',
  'systemProductDelete',
  'systemProductBindCourses',
  'systemChannel',
  'systemChannelCreate',
  'systemChannelEdit',
  'systemChannelDelete',
  'systemChannelToggle',
  'systemChannelChannelCreate',
  'systemChannelChannelEdit',
  'systemChannelChannelToggle',
  'systemChannelChannelDelete',
  'systemFeiShuTableConfigMapping',
  'systemFeiShuTableConfigMappingCreate',
  'systemFeiShuTableConfigMappingEdit',
  'systemFeiShuTableConfigMappingDelete',
  'systemFeiShuTableConfigMappingSync',
  'channelRules',
  'channelRulesCreate',
  'channelRulesEdit',
  'channelRulesDelete',
  'channelRulesRebuild',
  'trafficLandingPage',
  'trafficLandingPageCreate',
  'trafficLandingPageEdit',
  'trafficLandingPageDelete',
  'trafficLandingPageLink',
  'thirdPlatformMapService',
  'thirdPlatformMapServiceEdit',
  'thirdPlatformMapServiceLocate',
  'thirdPlatformMapServiceLog',
  'trafficAccount',
  'trafficAccountEdit',
  'trafficAccountBinding',
  'trafficAccountBindingEdit',
  'trafficTencentAdAccess',
  'trafficTencentAdAccessAppCreate',
  'trafficTencentAdAccessAppEdit',
  'trafficTencentAdAccessConnectionCreate',
  'trafficTencentAdAccessConnectionEdit',
  'trafficTencentAdAccessRefresh',
  'trafficWorkWxContact',
  'trafficWorkWxContactCreate',
  'trafficWorkWxContactEdit',
  'trafficWorkWxContactDelete',
  'trafficWorkWxContactConfigureCorp',
  'trafficWorkWxContactBindMember',
  'trafficWorkWxContactGenerate',
  'billBankStatement',
  'billBankStatementImport',
  'billBankStatementExport',
  'billTangLangStatement',
  'billTangLangStatementImport',
  'billTangLangStatementExport',
  'thirdPlatformBankStatement',
  'thirdPlatformBankStatementImport',
  'thirdPlatformBankStatementExport',
  'thirdPlatformBankUnionPayFlow',
  'thirdPlatformBankUnionPayFlowExport',
  'thirdPlatformWechatPayMerchant',
  'thirdPlatformWechatPayMerchantCreate',
  'thirdPlatformWechatPayMerchantEdit',
  'thirdPlatformWechatPayMerchantDelete',
  'thirdPlatformWechatPayMerchantSync',
  'thirdPlatformWechatPayFundFlow',
  'thirdPlatformWechatPayFundFlowExport',
  'thirdPlatformWechatPayTradeBill',
  'thirdPlatformWechatPayTradeBillExport',
  'thirdPlatformBaiduApp',
  'thirdPlatformBaiduAppCreate',
  'thirdPlatformBaiduAppEdit',
  'thirdPlatformBaiduAppAuthorize',
  'thirdPlatformBaiduAuthorization',
  'thirdPlatformBaiduAuthorizationRefresh',
  'thirdPlatformBaiduAuthorizationSync',
  'thirdPlatformBaiduAccountReport',
  'thirdPlatformBaiduAccountReportSync',
  'thirdPlatformXiaohongshuApp',
  'thirdPlatformXiaohongshuAppCreate',
  'thirdPlatformXiaohongshuAppEdit',
  'thirdPlatformXiaohongshuAppAuthorize',
  'thirdPlatformXiaohongshuAuthorization',
  'thirdPlatformXiaohongshuAccount',
  'thirdPlatformXiaohongshuAccountSync',
  'thirdPlatformXiaohongshuAccountReport',
  'thirdPlatformXiaohongshuAccountReportSync',
  'thirdPlatformQianchuanApp',
  'thirdPlatformQianchuanAppCreate',
  'thirdPlatformQianchuanAppEdit',
  'thirdPlatformQianchuanAppAuthorize',
  'thirdPlatformQianchuanAuthorization',
  'thirdPlatformQianchuanAuthorizationRefresh',
  'thirdPlatformQianchuanAuthorizedAccount',
  'thirdPlatformQianchuanAuthorizedAccountSync',
  'thirdPlatformQianchuanAccount',
  'thirdPlatformQianchuanAccountSync',
  'thirdPlatformQianchuanAccountReport',
  'thirdPlatformQianchuanAccountReportSync',
  'thirdPlatformIeh5Account',
  'thirdPlatformIeh5AccountToggle',
  'thirdPlatformIeh5AccountLogin',
  'thirdPlatformIeh5AdAccount',
  'thirdPlatformIeh5AdAccountSync',
  'thirdPlatformIeh5ShipinhaoReport',
  'thirdPlatformIeh5ShipinhaoReportSync',
  'thirdPlatformXingChengAccount',
  'thirdPlatformXingChengAccountCreate',
  'thirdPlatformXingChengAccountEdit',
  'thirdPlatformXingChengAccountLogin',
  'thirdPlatformXingChengAccountToggle',
  'systemPermission',
  'systemPermissionCreate',
  'systemPermissionEdit',
  'systemDataPermission',
  'systemDataPermissionCreate',
  'systemDataPermissionEdit',
  'systemDataPermissionDelete',
  'systemDataPermissionRoute',
  'systemDataPermissionRouteEdit',
  'systemDataPermissionRouteSync',
  'systemDataProtection',
  'systemDataProtectionEdit',
  'saleMarketIntentQuestionnaire',
  'saleMarketIntentQuestionnaireCreate',
  'saleMarketIntentQuestionnaireEdit',
  'saleMarketIntentQuestionnairePublish',
  'saleMarketIntentQuestionnaireDelete',
  'saleMarketIntentRespondent',
  'saleMarketIntentRespondentCreate',
  'saleMarketIntentRespondentEdit',
  'saleMarketIntentRespondentDelete',
  'saleMarketIntentTask',
  'saleMarketIntentTaskCreate',
  'saleMarketIntentTaskEdit',
  'saleMarketIntentTaskStart',
  'saleMarketIntentTaskClose',
  'saleMarketIntentResult',
  'saleMarketIntentResultExport',
  'trafficConversionConfig',
  'trafficConversionConfigCreate',
  'trafficConversionConfigEdit',
  'trafficConversionConfigTest',
  'trafficConversionLog',
  'trafficConversionLogRetry',
  'systemDepartment',
  'systemDepartmentCreate',
  'systemDepartmentEdit',
  'systemDepartmentMove',
  'systemDepartmentToggle',
  'systemDepartmentDelete',
  'systemDepartmentMembers',
  'systemDepartmentAdmins',
  'systemDepartmentResetPassword',
  'dataOrderCenter',
  'dataOrderCenterRepair',
  'dataTrack',
  'dataTrackRepair',
  'dataTrackBackfill',
  'saleManualPayOrder',
  'saleManualPayOrderEdit',
  'saleManualPayOrderSubmitAudit',
  'saleManualPayOrderAudit',
  'backendManualPayOrder',
  'backendManualPayOrderCreate',
  'backendManualPayOrderEdit',
  'backendManualPayOrderAudit',
  'thirdPlatformWorkWxUser',
  'thirdPlatformWorkWxUserBindEmployee',
  'thirdPlatformWorkWxCorp',
  'thirdPlatformWorkWxCorpConfigureContact',
  'workWxNativePaymentConfigure',
  'thirdPlatformTangLangPayOrder',
  'thirdPlatformTangLangPayOrderExport',
  'thirdPlatformTangLangRefundOrder',
  'thirdPlatformTangLangRefundOrderExport',
  'thirdPlatformFeiShuSaleOrder',
  'thirdPlatformFeiShuSaleOrderExport',
  'thirdPlatformFeiShuBackendSaleOrder',
  'thirdPlatformFeiShuBackendSaleOrderExport',
  'thirdPlatformWorkWxExternalPayBill',
  'thirdPlatformWorkWxExternalPayBillExport',
  'thirdPlatformWorkWxExternalRefundOrder',
  'thirdPlatformWorkWxExternalRefundOrderExport',
  'thirdPlatformWorkWxFundFlow',
  'thirdPlatformWorkWxFundFlowExport',
  'thirdPlatformWxShopFundsFlow',
  'thirdPlatformWxShopFundsFlowExport',
  'thirdPlatformWxShopOrderFlow',
  'thirdPlatformWxShopOrderFlowExport',
  'billSaleManualPayOrder',
  'billSaleManualPayOrderEdit',
  'billSaleManualPayOrderSubmitAudit',
  'billSaleManualPayOrderAudit',
  'billBackendManualPayOrder',
  'billBackendManualPayOrderCreate',
  'billBackendManualPayOrderEdit',
  'billBackendManualPayOrderAudit',
  'channelConversion',
] as const;
export default {
  dataCustomerList: ['dataCustomerListCreate', 'dataCustomerListEdit'],
  dataCustomerField: [
    'dataCustomerFieldCreate',
    'dataCustomerFieldEdit',
    'dataCustomerFieldReorder',
  ],
  dataCustomerStage: [
    'dataCustomerStageCreate',
    'dataCustomerStageEdit',
    'dataCustomerStageDelete',
    'dataCustomerStageToggle',
    'dataCustomerStageReorder',
  ],
  dataCustomerSource: [
    'dataCustomerSourceCreate',
    'dataCustomerSourceEdit',
    'dataCustomerSourceDelete',
    'dataCustomerSourceToggle',
    'dataCustomerSourceReorder',
  ],
  dataCustomerChannel: [
    'dataCustomerChannelCreate',
    'dataCustomerChannelEdit',
    'dataCustomerChannelDelete',
    'dataCustomerChannelToggle',
    'dataCustomerChannelReorder',
  ],
  dataWorkflow: [
    'dataWorkflowCreate',
    'dataWorkflowEdit',
    'dataWorkflowCopy',
    'dataWorkflowDelete',
    'dataWorkflowPublish',
    'dataWorkflowExecute',
    'dataWorkflowToggle',
    'dataWorkflowLogs',
  ],
  projectList: ['projectListCreate', 'projectListEdit', 'projectListDelete'],
  systemCourse: [
    'systemCourseCreate',
    'systemCourseEdit',
    'systemCourseDelete',
  ],
  systemCoursePeriod: [
    'systemCoursePeriodCreate',
    'systemCoursePeriodEdit',
    'systemCoursePeriodLessonEdit',
    'systemCoursePeriodLessonDelete',
    'systemCoursePeriodSyncLessons',
    'systemCoursePeriodSyncStudents',
  ],
  systemProduct: [
    'systemProductCreate',
    'systemProductEdit',
    'systemProductDelete',
    'systemProductBindCourses',
  ],
  systemChannel: [
    'systemChannelCreate',
    'systemChannelEdit',
    'systemChannelDelete',
    'systemChannelToggle',
    'systemChannelChannelCreate',
    'systemChannelChannelEdit',
    'systemChannelChannelToggle',
    'systemChannelChannelDelete',
  ],
  systemFeiShuTableConfigMapping: [
    'systemFeiShuTableConfigMappingCreate',
    'systemFeiShuTableConfigMappingEdit',
    'systemFeiShuTableConfigMappingDelete',
    'systemFeiShuTableConfigMappingSync',
  ],
  channelRules: [
    'channelRulesCreate',
    'channelRulesEdit',
    'channelRulesDelete',
    'channelRulesRebuild',
  ],
  trafficLandingPage: [
    'trafficLandingPageCreate',
    'trafficLandingPageEdit',
    'trafficLandingPageDelete',
    'trafficLandingPageLink',
  ],
  thirdPlatformMapService: [
    'thirdPlatformMapServiceEdit',
    'thirdPlatformMapServiceLocate',
    'thirdPlatformMapServiceLog',
  ],
  trafficAccount: ['trafficAccountEdit'],
  trafficAccountBinding: ['trafficAccountBindingEdit'],
  trafficTencentAdAccess: [
    'trafficTencentAdAccessAppCreate',
    'trafficTencentAdAccessAppEdit',
    'trafficTencentAdAccessConnectionCreate',
    'trafficTencentAdAccessConnectionEdit',
    'trafficTencentAdAccessRefresh',
  ],
  trafficWorkWxContact: [
    'trafficWorkWxContactCreate',
    'trafficWorkWxContactEdit',
    'trafficWorkWxContactDelete',
    'trafficWorkWxContactConfigureCorp',
    'trafficWorkWxContactBindMember',
    'trafficWorkWxContactGenerate',
  ],
  billBankStatement: ['billBankStatementImport', 'billBankStatementExport'],
  billTangLangStatement: [
    'billTangLangStatementImport',
    'billTangLangStatementExport',
  ],
  thirdPlatformBankStatement: [
    'thirdPlatformBankStatementImport',
    'thirdPlatformBankStatementExport',
  ],
  thirdPlatformBankUnionPayFlow: ['thirdPlatformBankUnionPayFlowExport'],
  thirdPlatformWechatPayMerchant: [
    'thirdPlatformWechatPayMerchantCreate',
    'thirdPlatformWechatPayMerchantEdit',
    'thirdPlatformWechatPayMerchantDelete',
    'thirdPlatformWechatPayMerchantSync',
  ],
  thirdPlatformWechatPayFundFlow: ['thirdPlatformWechatPayFundFlowExport'],
  thirdPlatformWechatPayTradeBill: ['thirdPlatformWechatPayTradeBillExport'],
  thirdPlatformBaiduApp: [
    'thirdPlatformBaiduAppCreate',
    'thirdPlatformBaiduAppEdit',
    'thirdPlatformBaiduAppAuthorize',
  ],
  thirdPlatformBaiduAuthorization: [
    'thirdPlatformBaiduAuthorizationRefresh',
    'thirdPlatformBaiduAuthorizationSync',
  ],
  thirdPlatformBaiduAccountReport: ['thirdPlatformBaiduAccountReportSync'],
  thirdPlatformXiaohongshuApp: [
    'thirdPlatformXiaohongshuAppCreate',
    'thirdPlatformXiaohongshuAppEdit',
    'thirdPlatformXiaohongshuAppAuthorize',
  ],
  thirdPlatformXiaohongshuAuthorization: [],
  thirdPlatformXiaohongshuAccount: ['thirdPlatformXiaohongshuAccountSync'],
  thirdPlatformXiaohongshuAccountReport: [
    'thirdPlatformXiaohongshuAccountReportSync',
  ],
  thirdPlatformQianchuanApp: [
    'thirdPlatformQianchuanAppCreate',
    'thirdPlatformQianchuanAppEdit',
    'thirdPlatformQianchuanAppAuthorize',
  ],
  thirdPlatformQianchuanAuthorization: [
    'thirdPlatformQianchuanAuthorizationRefresh',
  ],
  thirdPlatformQianchuanAuthorizedAccount: [
    'thirdPlatformQianchuanAuthorizedAccountSync',
  ],
  thirdPlatformQianchuanAccount: ['thirdPlatformQianchuanAccountSync'],
  thirdPlatformQianchuanAccountReport: [
    'thirdPlatformQianchuanAccountReportSync',
  ],
  thirdPlatformIeh5Account: [
    'thirdPlatformIeh5AccountToggle',
    'thirdPlatformIeh5AccountLogin',
  ],
  thirdPlatformIeh5AdAccount: ['thirdPlatformIeh5AdAccountSync'],
  thirdPlatformIeh5ShipinhaoReport: ['thirdPlatformIeh5ShipinhaoReportSync'],
  thirdPlatformXingChengAccount: [
    'thirdPlatformXingChengAccountCreate',
    'thirdPlatformXingChengAccountEdit',
    'thirdPlatformXingChengAccountLogin',
    'thirdPlatformXingChengAccountToggle',
  ],
  systemPermission: ['systemPermissionCreate', 'systemPermissionEdit'],
  systemDataPermission: [
    'systemDataPermissionCreate',
    'systemDataPermissionEdit',
    'systemDataPermissionDelete',
  ],
  systemDataPermissionRoute: [
    'systemDataPermissionRouteEdit',
    'systemDataPermissionRouteSync',
    'systemDataPermission',
    'systemDataPermissionCreate',
    'systemDataPermissionEdit',
    'systemDataPermissionDelete',
  ],
  systemDataProtection: ['systemDataProtectionEdit'],
  saleMarketIntentQuestionnaire: [
    'saleMarketIntentQuestionnaireCreate',
    'saleMarketIntentQuestionnaireEdit',
    'saleMarketIntentQuestionnairePublish',
    'saleMarketIntentQuestionnaireDelete',
  ],
  saleMarketIntentRespondent: [
    'saleMarketIntentRespondentCreate',
    'saleMarketIntentRespondentEdit',
    'saleMarketIntentRespondentDelete',
  ],
  saleMarketIntentTask: [
    'saleMarketIntentTaskCreate',
    'saleMarketIntentTaskEdit',
    'saleMarketIntentTaskStart',
    'saleMarketIntentTaskClose',
    'saleMarketIntentResult',
    'saleMarketIntentResultExport',
  ],
  saleMarketIntentResult: ['saleMarketIntentResultExport'],
  trafficConversionConfig: [
    'trafficConversionConfigCreate',
    'trafficConversionConfigEdit',
    'trafficConversionConfigTest',
  ],
  trafficConversionLog: ['trafficConversionLogRetry'],
  systemDepartment: [
    'systemRoleMembers',
    'systemDepartmentCreate',
    'systemDepartmentEdit',
    'systemDepartmentMove',
    'systemDepartmentToggle',
    'systemDepartmentDelete',
    'systemDepartmentMembers',
    'systemDepartmentAdmins',
    'systemDepartmentResetPassword',
  ],
  dataOrderCenter: ['dataOrderCenterRepair'],
  dataTrack: ['dataTrackRepair', 'dataTrackBackfill'],
  saleManualPayOrder: [
    'saleManualPayOrderEdit',
    'saleManualPayOrderSubmitAudit',
    'saleManualPayOrderAudit',
  ],
  backendManualPayOrder: [
    'backendManualPayOrderCreate',
    'backendManualPayOrderEdit',
    'backendManualPayOrderAudit',
  ],
  thirdPlatformWorkWxUser: ['thirdPlatformWorkWxUserBindEmployee'],
  thirdPlatformWorkWxCorp: ['thirdPlatformWorkWxCorpConfigureContact'],
  workWxNativePayment: ['workWxNativePaymentConfigure'],
  thirdPlatformTangLangPayOrder: ['thirdPlatformTangLangPayOrderExport'],
  thirdPlatformTangLangRefundOrder: ['thirdPlatformTangLangRefundOrderExport'],
  thirdPlatformFeiShuSaleOrder: ['thirdPlatformFeiShuSaleOrderExport'],
  thirdPlatformFeiShuBackendSaleOrder: [
    'thirdPlatformFeiShuBackendSaleOrderExport',
  ],
  thirdPlatformWorkWxExternalPayBill: [
    'thirdPlatformWorkWxExternalPayBillExport',
  ],
  thirdPlatformWorkWxExternalRefundOrder: [
    'thirdPlatformWorkWxExternalRefundOrderExport',
  ],
  thirdPlatformWorkWxFundFlow: ['thirdPlatformWorkWxFundFlowExport'],
  thirdPlatformWxShopFundsFlow: ['thirdPlatformWxShopFundsFlowExport'],
  thirdPlatformWxShopOrderFlow: ['thirdPlatformWxShopOrderFlowExport'],
  billSaleManualPayOrder: [
    'billSaleManualPayOrderEdit',
    'billSaleManualPayOrderSubmitAudit',
    'billSaleManualPayOrderAudit',
  ],
  billBackendManualPayOrder: [
    'billBackendManualPayOrderCreate',
    'billBackendManualPayOrderEdit',
    'billBackendManualPayOrderAudit',
  ],
  channelConversion: [],
} satisfies Record<string, string[]>;
